var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCliparts(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 48,
    viewBox: "0 -960 960 960",
    width: 48,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M197.694-140.001q-23.529 0-40.611-17.082-17.082-17.082-17.082-40.611v-564.612q0-23.529 17.082-40.611 17.082-17.082 40.611-17.082h564.612q23.529 0 40.611 17.082 17.082 17.082 17.082 40.611v564.612q0 23.529-17.082 40.611-17.082 17.082-40.611 17.082H197.694Zm0-45.384h564.612q4.616 0 8.463-3.846 3.846-3.847 3.846-8.463v-564.612q0-4.616-3.846-8.463-3.847-3.846-8.463-3.846H197.694q-4.616 0-8.463 3.846-3.846 3.847-3.846 8.463v564.612q0 4.616 3.846 8.463 3.847 3.846 8.463 3.846Zm69.462-102.385h429.765L567.23-460.307 446.385-306.231l-82.23-107.383-96.999 125.844Zm-81.771 102.385V-774.615-185.385ZM340.14-577.308q17.783 0 30.167-12.525 12.385-12.525 12.385-30.307 0-17.783-12.525-30.167-12.525-12.385-30.307-12.385-17.783 0-30.167 12.525-12.385 12.525-12.385 30.307 0 17.783 12.525 30.167 12.525 12.385 30.307 12.385Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCliparts);
export default __webpack_public_path__ + "static/media/cliparts.adf79f44e9d21f69d84c14deca100008.svg";
export { ForwardRef as ReactComponent };